import React from 'react';
import { AppProvider } from '../context/AppContext';
import ViewManager from './ViewManager/ViewManager';
import './ExperienceFlow.module.scss';

const ExperienceFlow = () => {
  return (
    <AppProvider>
      <div className="experience-flow">
        <ViewManager />
      </div>
    </AppProvider>
  );
};

export default ExperienceFlow;
